import { render, staticRenderFns } from "./AddMatch.vue?vue&type=template&id=21787d58&scoped=true&"
import script from "./AddMatch.vue?vue&type=script&lang=js&"
export * from "./AddMatch.vue?vue&type=script&lang=js&"
import style0 from "./AddMatch.vue?vue&type=style&index=0&id=21787d58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21787d58",
  null
  
)

export default component.exports